/*
Local dev:
- API defaults to relative path so CRA proxy can handle it.
- Inference defaults to explicit Render inference URL unless overridden.

Supported values:
  REACT_APP_API_BASE=relative  -> ""
  REACT_APP_API_BASE=local     -> ""
  REACT_APP_API_BASE=https://your-api.example -> used as-is

  REACT_APP_INFERENCE_BASE=https://your-inference.example -> used as-is
*/

const isProd = process.env.NODE_ENV === 'production';

const RAW_API = String(
  process.env.REACT_APP_API_BASE || process.env.VITE_API_BASE || ''
).trim();

const RAW_INFERENCE = String(
  process.env.REACT_APP_INFERENCE_BASE || ''
).trim();

function isPublicBrightResolveHost() {
  if (typeof window === 'undefined') return false;
  const host = String(window.location.hostname || '').toLowerCase();
  return host === 'brightresolve.ai' || host === 'www.brightresolve.ai';
}

export function normalizeApi(val) {
  // Authentication is cookie-based. The public web application must therefore
  // use its own origin, where the Cloudflare Worker forwards only approved
  // product routes to Render. This keeps Safari on first-party cookies.
  if (isProd && isPublicBrightResolveHost()) return '';
  if (!val) return isProd ? 'https://api.brightresolve.ai' : '';

  const v = val.toLowerCase();

  if (v === 'relative') return '';
  if (v === 'local') return '';
  if (v.startsWith('http://') || v.startsWith('https://')) {
    return val.replace(/\/+$/, '');
  }

  return isProd ? 'https://api.brightresolve.ai' : '';
}

function normalizeInference(val) {
  if (!val) return 'https://brightresolve-inference.onrender.com';

  const v = val.toLowerCase();
  if (v.startsWith('http://') || v.startsWith('https://')) {
    return val.replace(/\/+$/, '');
  }

  return 'https://brightresolve-inference.onrender.com';
}

const apiBase = normalizeApi(RAW_API);
const inferenceBase = normalizeInference(RAW_INFERENCE);

export { apiBase, inferenceBase };
export default apiBase;
